import React from 'react';
import './assets/css/menu.css';
import { BrowserRouter as Router, Link } from "react-router-dom";

class Menu extends React.Component {
    render(){
        return(
        <div className="menu-bar" id="menu-bar">
            <div className="menu-bar-left">
                <div className="menu-bar-left-links" id="menu-bar-left-links">
                    <ul>
                        <h1 id="waifu-title">WAIFU</h1>
                        <li><a href="https://discordapp.com/api/oauth2/authorize?client_id=637108716151504926&permissions=2147483127&scope=bot" id="menu-bar-invite">Invite</a></li>
                        <li><a id="menu-bar-documentation"><Link to="/documentation">Documentation</Link></a></li>
                        <li><a id="menu-bar-home"><Link to="/">Home</Link></a></li> 
                    </ul>
                </div>
            </div>
        </div>
        )
    };
}

export default Menu;